module.exports = __webpack_public_path__ + "img/140.8e88c32a.jpg";